export default __webpack_public_path__ + "static/beer-48e738e39b49800bc2b8cac1d5dbc171.jpg";